import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Rename = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M15 10C14.448 10 14 10.448 14 11V11.533C12.938 10.581 11.536 10 10 10C6.691 10 4 12.691 4 16C4 19.309 6.691 22 10 22C11.536 22 12.938 21.419 14 20.467V21C14 21.552 14.448 22 15 22C15.552 22 16 21.552 16 21V11C16 10.448 15.552 10 15 10ZM10 20C7.794 20 6 18.206 6 16C6 13.794 7.794 12 10 12C12.206 12 14 13.794 14 16C14 18.206 12.206 20 10 20Z" />
		<path d="M27 26C25.154 26 24.287 25.096 24 24.71V7.29C24.287 6.904 25.154 6 27 6C27.552 6 28 5.552 28 5C28 4.448 27.552 4 27 4C25.003 4 23.728 4.763 22.98 5.455C22.217 4.768 20.932 4 19 4C18.448 4 18 4.448 18 5C18 5.552 18.448 6 19 6C20.761 6 21.679 6.908 22 7.312V24.71C21.713 25.097 20.846 26 19 26C18.448 26 18 26.448 18 27C18 27.552 18.448 28 19 28C20.98 28 22.25 27.25 23 26.562C23.75 27.25 25.02 28 27 28C27.552 28 28 27.552 28 27C28 26.448 27.552 26 27 26Z" />
	</svg>
);

export default Rename;
